import sagaManager from '../../sagaManager';
import * as shadeXInciActions from './shadeXInciActions';
import sagas from './shadeXInciSagas';
import * as shadeXInciSelectors from './shadeXInciSelectors';
import * as shadeXInciTypes from './shadeXInciTypes';

sagaManager.addSagaToRoot(sagas);

export { shadeXInciSelectors, shadeXInciActions, shadeXInciTypes };
